// extracted by mini-css-extract-plugin
module.exports = {"section":"DetailsSection_section__Mwmrq","titleContainer":"DetailsSection_titleContainer__2rUzb","sectionDivider":"DetailsSection_sectionDivider__Pg8I0"};